    <div class="connection-list mb-3" 
        *ngIf="memberList.length > numberZero">
        <div class="list-connection" 
            infiniteScroll 
            [infiniteScrollDistance]="1" 
            [infiniteScrollThrottle]="1000"
            (scrolled)="onScroll()" 
            [scrollWindow]="true">
            <div class="py-3 px-3 mb-3 connection-card bg-white" 
                *ngFor="let suggObj of memberList; let index=index">
                <app-connection-card 
                    [callingfrom]="callingFrom" 
                    [usercardsize]="'m'" 
                    [suggObj]="suggObj"
                    [idx]="index" 
                    (resetSuggList)=resetSuggList($event)>
                </app-connection-card>
            </div>
        </div>
    </div>
    <div class='text-center'>
        <img *ngIf="finished && masterService.isOnline === true" class="text-center"
            src="assets/themes/images/img-video-loader.gif" 
            width="40" 
            id="loadmore_post" 
            alt="loading icon" />
    </div>
    
    <div *ngIf="!finished && memberList.length === numberZero && offset === numberZero" class='text-center p-3'>
        <img class="no-data-image mb-3" src="assets/themes/images/no-connections.svg" alt="no data" /><br />
        <span><b>{{mls.languageText.community.key62}}</b></span>
    </div>
    
    <app-info-modal 
        (resetInfoModal)="resetInfoModal()" 
        [isInfoModalShown]="isInfoModalShown" 
        [info_msg]="info_msg">
    </app-info-modal>